export const LOGIN_TOOLTIP = "Login to the Dashboard to access Leave and Timesheets";

export const MODALITIES = [
  "XR",
  "CT",
  "MR",
  "US",
  "BMD",
  // Never used in production, keep here in case they are needed later - they are valid modalities
  // "OPG",
  // "COOLSCULPT",
  // "RESURFX",
];
